<div fxLayout="row" fxLayoutAlign="space-between center" @fade>
  <!--
  <div #wrapper
       fxFlex>
    <ng-content select="ian-default-toolbar-content"></ng-content>
  </div>
  -->

  <mat-form-field [fxFlex]="inputFlex" [style.visibility]="showTextSearchInput ? 'visible' : 'hidden'">
    <mat-icon class="grey-icon" matSuffix>search</mat-icon>
    <input
      type="text"
      matInput
      #searchInput
      placeholder="{{ 'COMP.DEFAULT_TBAR.SEARCH' | pTranslate }}"
      (blur)="inputFlex=50"
      (focus)="inputFlex=75"
      [attr.data-test-id]="'list-search'"
      [disabled]="disableTextSearchInput"
    />
  </mat-form-field>

  <ng-content select="[toolbar-middle-actions]"></ng-content>

  <!-- TODO: VOLVER ESTO A fxHide  -->
  <div fxHide [fxHide.gt-sm]="false">
    <ng-container *ngTemplateOutlet="buttons;context:{actions: actions, isGtSm: isGtSm()}"></ng-container>
  </div>
  <div fxShow [fxShow.gt-sm]="false" *ngIf="showMobileMenu">
    <button mat-icon-button [matMenuTriggerFor]="menu1">
      <mat-icon class="grey-icon">more_vert</mat-icon>
    </button>

    <mat-menu #menu1="matMenu">
      <ng-container *ngTemplateOutlet="buttons;context:{actions: actions, isGtSm: isGtSm()}"></ng-container>
    </mat-menu>
  </div>
</div>
<ng-template #buttons let-actions="actions" let-isGtSm="isGtSm">
  <ng-container *ngFor="let action of actions">
    <ng-container *ngIf="isGtSm && (!action.children || action.children.length === 0)">
      <ng-container *ngTemplateOutlet="button;context:{action: action}"></ng-container>
    </ng-container>
    <ng-container *ngIf="isGtSm && (action.children && action.children.length > 0)">
      <ng-container *ngTemplateOutlet="buttonMenu;context:{action: action}"></ng-container>
    </ng-container>

    <ng-container *ngIf="!isGtSm && (!action.children || action.children.length === 0)">
      <ng-container *ngTemplateOutlet="buttonResponsive;context:{action: action}"></ng-container>
    </ng-container>
    <ng-container *ngIf="!isGtSm && (action.children && action.children.length > 0)">
      <ng-container *ngTemplateOutlet="buttonResponsiveMenu;context:{action: action}"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>
<!-- used on advanced filter  -->
<ng-template #button let-action="action">
  <span [matTooltip]="action.tooltip" [ngClass]="action?.classActive ? action.iconClass : null">
    <button
      mat-icon-button
      *ngIf="action.show !== false"
      [disabled]="action.disabled"
      [ngClass]="action?.classButton ? action.classButton : null"
      (click)="emitActionExecution(action)"
    >
      <mat-icon [ngClass]="action.iconClass" *ngIf="action.type != 'filter' && action.icon != 'lamp' ">
        {{action.icon}}
      </mat-icon>
      <img
        [ngStyle]="{'opacity': action.disabled ? '0.3' : '1'}"
        src="assets/icons/lamp.svg"
        class="small-icon lamp_svg"
        *ngIf="action.icon === 'lamp'"
      />
      <mat-icon
        *ngIf="action.type === 'filter'"
        [ngClass]="{'grey-icon': !(isAdvancedSearch$ | async), 'ian-green': (isAdvancedSearch$ | async)}"
      >
        {{action.icon}}
      </mat-icon>
    </button>
  </span>
</ng-template>

<ng-template #buttonMenu let-action="action">
  <button
    mat-icon-button
    [ngClass]="action?.classActive || action.iconClass === 'grey-icon' ? action.iconClass : null"
    [matTooltip]="action.tooltip"
    [disabled]="action.disabled"
    [matMenuTriggerFor]="options"
  >
    <mat-icon>{{action.icon}}</mat-icon>
  </button>
  <mat-menu #options="matMenu">
    <button
      *ngFor="let item of action.children"
      mat-menu-item
      [matTooltip]="item.tooltip"
      [disabled]="item.disabled"
      (click)="emitActionExecution(item)"
    >
      {{ item.name }}
    </button>
  </mat-menu>
</ng-template>

<ng-template #buttonResponsive let-action="action">
  <button mat-menu-item [disabled]="action.disabled" (click)="emitActionExecution(action)">
    <mat-icon *ngIf="action.type === 'filter'">{{action.icon}}</mat-icon>
    <mat-icon
      *ngIf="action.type !== 'filter'"
      [ngClass]="{'grey-icon': !(isAdvancedSearch$ | async), 'ian-green': (isAdvancedSearch$ | async)}"
    >
      {{action.icon}}
    </mat-icon>

    {{action.name}}
  </button>
</ng-template>

<ng-template #buttonResponsiveMenu let-action="action">
  <ng-container>
    <button mat-menu-item [disabled]="action.disabled" [matMenuTriggerFor]="optionsResponsive">
      <mat-icon>{{action.icon}}</mat-icon>
      <span>{{action.name}}</span>
      <mat-icon class="collapsable-arrow">keyboard_arrow_right</mat-icon>
    </button>
    <mat-menu #optionsResponsive="matMenu" xPosition="after" overlapTrigger="true">
      <ng-container *ngFor="let item of action.children">
        <button mat-menu-item [disabled]="item.disabled" (click)="emitActionExecution(item)">
          <mat-icon>{{item.icon}}</mat-icon>
          <span>{{item.name}}</span>
        </button>
      </ng-container>
    </mat-menu>
  </ng-container>
</ng-template>
